<template>
  <div class="capacity">
    <div class="provider-category">
      <span :class="['icon', 'icon-passengers']" />
      <span class="name">
        {{ passengers }}
      </span>
    </div>
    <div class="provider-category">
      <span :class="['icon', 'icon-bags']" />
      <span class="name">
        {{ bags }}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Capacity',
  props: {
    passengers: {
      type: Number,
      required: true,
      default: 1,
    },
    bags: {
      type: Number,
      required: true,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
  .capacity {
    display: inline-block;
  }

  .provider-category {
    display: inline-block;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    color: #444;
    position: relative;
    border-left: 16px solid transparent;
  }

  .icon {
    width: 12px;
    height: 12px;
    display: inline-block;
    position: absolute;
    left: -16px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .icon-passengers {
    background-image: url('../../../assets/svg/icon_passengers.svg');
  }

  .icon-bags {
    background-image: url('../../../assets/svg/icon_bags.svg');
  }

  .name {
    padding-right: 10px;
  }
</style>
